export default __webpack_public_path__ + "static/media/login-hero.3d7b6a56.png";